import React from 'react';
import './App.css';
import Routes from './routes/index';
import {useSelector} from "react-redux";
import {Helmet, HelmetProvider} from "react-helmet-async";
import DateFnsUtils from "@date-io/date-fns";

import { ThemeProvider } from "styled-components/macro";
import {create} from "jss";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider} from "@mui/material/styles";

import jssPreset from '@mui/styles/jssPreset';
import StylesProvider from '@mui/styles/StylesProvider';

import createTheme from "./theme";
import {CurrentUserProvider} from "./components/CurrentUserContext";
import NotificationContextProvider from "./components/NotificationContext";

const jss = create({
    ...jssPreset(),
    insertionPoint: document.getElementById("jss-insertion-point"),
});

function App() {  
    const theme = useSelector((state) => state.themeReducer);
    localStorage.removeItem('code');
    
    return (
        <React.Fragment>
            <HelmetProvider>
                <Helmet
                    titleTemplate="%s | PFSCM Tools"
                    defaultTitle="PFSCM Tools"
                />
                <StylesProvider jss={jss}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <StyledEngineProvider injectFirst>
                            <MuiThemeProvider theme={createTheme(theme.currentTheme)}>
                                <ThemeProvider theme={createTheme(theme.currentTheme)}>
                                    <NotificationContextProvider>
                                        <CurrentUserProvider>
                                            <Routes/>
                                        </CurrentUserProvider>
                                    </NotificationContextProvider>
                                </ThemeProvider>
                            </MuiThemeProvider>
                        </StyledEngineProvider>
                    </MuiPickersUtilsProvider>
                </StylesProvider>
            </HelmetProvider>
        </React.Fragment>
    );
}

export default App;
